import { type ReactElement } from 'react';
import PageShell, { PageSection } from '../components/PageShell';

export default function Lizenzen(): ReactElement {
  return (
    <PageShell
      title="Lizenzen"
      intro="Saldify nutzt Open-Source-Software. Wir danken den Projekten und ihren Communities."
    >
      <PageSection title="Verwendete Open-Source-Software">
        <p>
          Saldify basiert unter anderem auf folgenden Open-Source-Komponenten, die
          unter ihren jeweiligen Lizenzen (u. a. MIT, Apache 2.0, BSD) bereitgestellt
          werden:
        </p>
        <ul className="list-disc pl-6 mt-3 space-y-1">
          <li>React, React Router</li>
          <li>Vite</li>
          <li>Tailwind CSS</li>
          <li>Lucide Icons</li>
          <li>Fastify, Prisma</li>
        </ul>
      </PageSection>

      <PageSection title="Lizenzhinweise">
        <p>
          Die vollständigen Lizenztexte der eingesetzten Bibliotheken stellen wir auf
          Anfrage gerne zur Verfügung. Wenden Sie sich dafür an{' '}
          <a href="mailto:info@saldify.de" className="text-primary-600 hover:underline">
            info@saldify.de
          </a>
          .
        </p>
      </PageSection>
    </PageShell>
  );
}
